import { createAction, props } from '@ngrx/store';

const ACTION_KEY = '[Inbox search]';

export const setSearchTerm = createAction(
  `${ACTION_KEY} set search`,
  props<{ searchText: string }>(),
);
